import { createFileRoute, useRouter } from '@tanstack/react-router'

import styles from './styles.module.scss'
import { cardsServiceInstance } from '@/services/cards.service'
import { useMemo } from 'react'
import { currencyFormat } from '@/utils/currency-format'

export const Route = createFileRoute('/desktop/__app/my-cards/$card/')({
  component: RouteComponent,
  async loader({ params: { card: cardId } }) {
    const card = await cardsServiceInstance.get(cardId)

    return card
  },
  shouldReload: true,
})

function RouteComponent() {
  const card = Route.useLoaderData()
  const router = useRouter()
  const quantityOcurrences = useMemo(() => {
    let ocurrences = 0

    for (const number of card.cardBalls) {
      if (card.drawBalls.includes(number)) ocurrences++
    }
    return ocurrences
  }, [card])

  return (
    <div className={styles.container}>
      <header>
        <button onClick={() => router.history.back()}>
          <img
            src="/assets/back_button_desk.png"
          />
        </button>
        <h3>Detalhes do sorteio</h3>
      </header>

      <div className={styles.flex_container}>
        <div>
          <div className={styles.grid_container}>
            <ul>
              {card.drawBalls.map((b) => (
                <li key={b}>
                  <img
                    src={`/assets/balls/${b}.svg`}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className={styles.container_result_summary}>
            <div>
              <b>Acertos</b>
              <span>{quantityOcurrences}</span>
            </div>
            <div>
              <b>Prêmio</b>
              <span>{currencyFormat(card.priceValue)}</span>
            </div>
          </div>
        </div>
        <div>
          <div className={styles.container_result}>
            <div>
              <ul>
                {card.cardBalls.map((c) => (
                  <li key={c}>
                    {
                      card.drawBalls.includes(c) ? (
                        <img
                          src={`/assets/balls/${c}.svg`}
                        />
                      ) : (
                        <b>{c}</b>
                      )
                    }

                  </li>
                ))}
              </ul>
            </div>

          </div>
          <div className={styles.container_identificator}>
            <span>ID: {card.key}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
